import { Pagination, PaginationControls } from '@common/types/pagination';

interface UsePaginationControlsProps {
    pageCount: number;
    pageIndex: number;
    pageSize: number;
    pageSizes: number[];
    onPaginationChange?: (pagination: Pagination) => void;
}

export const usePaginationControls = ({
    pageCount,
    pageIndex,
    pageSize,
    pageSizes,
    onPaginationChange,
}: UsePaginationControlsProps): PaginationControls => {
    const hasNextPage = pageIndex + 1 < pageCount;
    const hasPreviousPage = pageIndex > 0;

    const nextPage = () => {
        if (hasNextPage) {
            onPaginationChange?.({ pageIndex: pageIndex + 1, pageSize });
        }
    };

    const previousPage = () => {
        if (hasPreviousPage) {
            onPaginationChange?.({ pageIndex: pageIndex - 1, pageSize });
        }
    };

    const handleSetPageIndex = (newPageIndex: number) => {
        if (newPageIndex >= 0 && newPageIndex < pageCount) {
            onPaginationChange?.({ pageIndex: newPageIndex, pageSize });
        }
    };

    const handleSetPageSize = (newPageSize: number) => {
        if (pageSizes.includes(newPageSize)) {
            onPaginationChange?.({ pageSize: newPageSize, pageIndex });
        }
    };

    return {
        pageIndex,
        hasNextPage,
        hasPreviousPage,
        pageCount,
        pageSize,
        pageSizes,

        nextPage,
        previousPage,
        setPageIndex: handleSetPageIndex,
        setPageSize: handleSetPageSize,
    };
};
